<template>
	<div class="right_zs fl test">
		<!-- 巡检风险状态 -->
		<div class="data-box1 right_tb">
			<i class="topL"></i>
			<i class="topR"></i>
			<i class="bottomL"></i>
			<i class="bottomR"></i>
			<div class="data-title">
				<b class="data-title-left">[</b>
				<span>{{$tt('总览')}}</span>
				<b class="data-title-right">]</b>
			</div>
			<div class="wenti_bg wenti_bg_statistics">
				<table class="statistics_table" size="small">
					<tbody class="numberDisplay">
						<tr>
							<td>
								<p>{{$tt('充电次数(次)')}}</p>
								<span>{{OverviewTotal.ChargeNum}}</span>
							</td>
							<td>
								<p>{{$tt('充电电量(度)')}}</p>
								<span>{{OverviewTotal.ChargeKwh}}</span>
							</td>
							<td>
								<p>{{$tt('充电时长(小时)')}}</p>
								<span>{{OverviewTotal.ChargeDuration}}</span>
							</td>
						</tr>
						<tr>
							<td>
								<p>{{$tt('充电费用(元)')}}</p>
								<span>{{OverviewTotal.ChargeCost}}</span>
							</td>
							<td>
								<p>{{$tt('充电电费(元)')}}</p>
								<span>{{OverviewTotal.ChargeCostElec}}</span>
							</td>
							<td>
								<p>{{$tt('充电服务费(元)')}}</p>
								<span>{{OverviewTotal.ChargeCostService}}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- 批次信息查询 -->
		<div class="data-box1 right_tb2 mtop40">
			<i class="topL"></i>
			<i class="topR"></i>
			<i class="bottomL"></i>
			<i class="bottomR"></i>
			<div class="data-title">
				<b class="data-title-left">[</b>
				<span>{{$tt('24小时走势图')}}</span>
				<b class="data-title-right">]</b>
			</div>
			<!--问题等级-->
			<div class="rightBottom">
				<div id="charginEchart2" style="width: 100%;height: 90%;">
				</div>
			</div>
		</div>
		<div class="data-box1 right_tb3 mtop40">
			<i class="topL"></i>
			<i class="topR"></i>
			<i class="bottomL"></i>
			<i class="bottomR"></i>
			<div class="data-title">
				<b class="data-title-left">[</b>
				<span>{{$tt('费用统计')}}</span>
				<b class="data-title-right">]</b>
			</div>
			<div class="rightStyle" style="margin-top: 20px;">
				<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
					<FormItem prop="trackName" :label="$tt('选择查询类型:')" :label-width="100">
						<Select @on-change="changeDayMY" v-model="dayMY" :placeholder="$tt('费用统计信息')" style="width: 200px;">
							<Option value="日视图">{{$tt('日视图')}}</Option>
							<Option value="月视图">{{$tt('月视图')}}</Option>
							<Option value="年视图">{{$tt('年视图')}}</Option>
						</Select>
					</FormItem>
				</Form>
			</div>
			<div id="charginEchart" style="width: 100%;height: 60%;">
			</div>
		</div>
	</div>
</template>

<script>
	import bus from './bus.js'
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import echart from '../../../js/echarts_hot.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		props: [
			'batchSelectList',
			'deviceTypeSelectList'
		],
		data() {
			return {
				//总览统计信息
				OverviewTotal: {
					MemberNum: 0,
					ChargeNum: 0,
					ChargeKwh: 0,
					ChargeDuration: 0,
					ChargeCost: 0,
					ChargeCostElec: 0,
					ChargeCostService: 0,
					EmissionReductionNum: 0,
				},
				//右上费用年月日
				dayMY: '月视图',
				//月试图是否加载
				ifInitBar: false,
				formInline: {
					StationId: 0,
				},
				columnsBatch: [{
						title: this.$tt('批次'),
						key: 'batch',
						width: 200
					},
					{
						title: this.$tt('基站总数'),
						key: 'fhm200',
					},
					{
						title: this.$tt('镣铐总数'),
						key: 'fsj200',
					}, {
						title: this.$tt('提醒器总数'),
						key: 'fba200',
					}
				],
				columnsDevices: [{
						title: this.$tt('枪编号'),
						key: 'ConnectorNo'
					},
					{
						title: this.$tt('工作状态'),
						key: 'WorkStatus',
						render: (h, params) => {
							let type = ''
							switch (params.row.WorkStatus) {
								case 0:
									type = "空闲"
									break;
								case 1:
									type = "充电启动中"
									break;
								case 2:
									type = "充电中"
									break;
								case 6:
									type = "故障"
									break;
								case -1:
									type = "离线"
									break;
								default:
									type = "其他"
									break;
							}
							return h('div',
								type
							);
						}
					},
					{
						title: this.$tt('连接状态'),
						key: 'CarCoupleStatus',
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.CarCoupleStatus) {
								case 0:
									color = "error",
										type = "未连接"
									break;
								default:
									color = "success",
										type = "已连接"
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					{
						title: this.$tt('站点名称'),
						key: 'StationName'
					}
				],
				//图表数据
				barEchart: {
					legend_data: ['充电电费', '充电服务费', '充电总费用'],
					seriesData: [{
							name: '充电电费',
							type: 'bar',
							stack: '分量',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '充电服务费',
							type: 'bar',
							stack: '分量',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '充电总费用',
							type: 'bar',
							stack: '总量',
							data: [0, 0, 0, 0, 0, 0, 0]
						}
					],
					style: {
						color: "#00ff7f"
					},
					TimePoins: [1, 2, 3, 4, 5, 6, 7]
				},
				//图表数据
				lineEchart: {
					legend_data: ['充电次数', '充电电量'],
					seriesData: [{
							name: '充电次数',
							type: 'line',
							stack: '分量1',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '充电电量',
							type: 'line',
							stack: '分量2',
							yAxisIndex: 1,
							data: [0, 0, 0, 0, 0, 0, 0]
						}
					],
					style: {
						color: "#00ff7f"
					},
					TimePoins: [1, 2, 3, 4, 5, 6, 7]
				},
				timer: null,
			}
		},
		components: {
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations'
			}),
		},
		mounted() {
			this.getOverviewTotal();
			this.changeDayMY();
			//24小时充电走势图
			this.GetTrendChart();
			//echart.initBarechart("charginEchart2", this.lineEchart)
			window.addEventListener('resize', function() {
				console.log(11111111)
				echart.resizeEchart(null);
			});
			this.timer = setInterval(() => {
				this.getOverviewTotal();
				this.changeDayMY()
				this.GetTrendChart()
			}, 60000);
		},
		created() {},
		activated() {},
		destroyed() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		},
		deactivated() {},
		watch: {
		},
		methods: {
			//总数 最上面表格数据
			getOverviewTotal: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/GetOverviewTotal", ).then(res => {
					if (res.data.code != 1) {
						console.log(res.data);
						_this.OverviewTotal = res.data.Data
					}
				})
			},
			//选择年月日
			changeDayMY: function() {
				const _this = this;
				console.log(_this.dayMY)
				let url = ''
				switch (_this.dayMY) {
					case "日视图":
						url = webapi.base_api_url + "/Overview/GetDailyFee";
						break;
					case "年视图":
						url = webapi.base_api_url + "/Overview/GetYearlyFee";
						break;
					case "月视图":
						url = webapi.base_api_url + "/Overview/GetMonthlyFee";
						break;
				}
				this.$axios.post(url, {}).then(res => {
					console.log("nianyueri数据");
					console.log(res.data.Data);
					_this.barEchart.TimePoins = res.data.Data.TimePoints
					_this.barEchart.seriesData[0].data = res.data.Data.ChargeFees
					_this.barEchart.seriesData[1].data = res.data.Data.ServiceFees
					_this.barEchart.seriesData[2].data = res.data.Data.TotalFees
					if (!_this.ifInitBar) {
						echart.initBarechart("charginEchart", this.barEchart)
					}
					echart.upEchartOpt("charginEchart")
				})
			},
			//充电走势数据
			GetTrendChart: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + '/Overview/GetTrendChart', {}).then(res => {
						console.log("充电走势数据");
						console.log(res.data.Data);
						_this.lineEchart.TimePoins = res.data.Data.TimePoint
						_this.lineEchart.seriesData[0].data = res.data.Data.ChargeNum
						_this.lineEchart.seriesData[1].data = res.data.Data.ChargeKwh
						echart.initLinechart("charginEchart2", _this.lineEchart)
					})
					.catch(function(err) {
						console.log("充电走势数据2");
						console.log(err);
						console.log("充电走势数据3");
						echart.initLinechart("charginEchart2", _this.lineEchart)
					});
			},
		}
	}
</script>

<style>
	.test {
		transition: all 2s;
	}

	.rightBottom {
		height: 100%;
	}

	.rightStyle .ivu-input {
		display: inline-block;
		width: 100%;
		height: 32px;
		line-height: 1.5;
		padding: 4px 7px;
		font-size: 12px;
		border: 1px solid #1e3d2c !important;
		border-radius: 4px;
		color: #ffffff !important;
		background-color: transparent !important;
	}

	/* 下拉框定制* */
	.rightStyle .ivu-select-dropdown {
		background-color: #121d14 !important;
		color: #00FF00;
	}

	.rightStyle .ivu-select-selection {
		background-color: transparent !important;
		color: #00FF00;
	}

	.rightStyle .ivu-select-item {
		color: #00FF00 !important;
	}

	.wenti_bg_statistics {
		padding-top: 25px;
		height: 100%;
	}

	.statistics_table {
		height: 100%;
	}

	.numberDisplay p {
		display: block;
		border-left: 4px solid green;
		padding-left: 2px;
	}

	.numberDisplay td {
		width: 33%;
	}

	.numberDisplay span {
		font-size: 20px;
		color: #83c7e3;
		text-align: center;
	}
</style>
